import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {
  Box,
  Button,
  Fade,
  FormControl,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import image from "../Images/Email-campaign-pana-1.svg";
import { useEffect, useImperativeHandle, useState, forwardRef } from "react";
import BaseUrl from "../BaseUrl";
import axios from "axios";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Backdrop from "@mui/material/Backdrop";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const breadcrumbs = [
  <Typography
    key="3"
    sx={{
      color: "#1C485F",
      fontFamily: "Source Sans 3",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 500,
    }}
  >
    Email Verification
  </Typography>,
  <Typography
    key="3"
    sx={{
      color: "#1C485F",
      fontFamily: "Source Sans 3",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 500,
    }}
  >
    Individual Email Verification
  </Typography>,
];

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Email id",
  },
  {
    id: "calories",
    numeric: true,
    disablePadding: false,
    label: "User name",
  },
  // {
  //   id: "fat",
  //   numeric: true,
  //   disablePadding: false,
  //   label: "Move to list",
  // },
  {
    id: "carbs",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "protein",
    numeric: true,
    disablePadding: false,
    label: "Action",
  },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid transparent",
  borderRadius: "7px",
  boxShadow: 24,
  p: 2,
};
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            sx={{
              color: "#1C485F",
              "&.Mui-checked": {
                color: "#1C485F",
              },
            }}
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all items",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "center" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              color: "#4B4B4B",
              fontFamily: "Source Sans 3",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 700,
            }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const Mailverification = (props) => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [allIndividualEmails, setAllIndividualEmails] = useState([]);
  const [allIndividualEmailsCopy, setAllIndividualEmailsCopy] = useState([]);
  const [fetched, setFetched] = useState(false);
  const [catchEmail, setCatchEmail] = useState("");
  const [selected, setSelected] = useState([]);
  const [nameListArr, setNameListArr] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [nameList, setNameList] = useState("");
  const [nameListObj, setNameListObj] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [emailError, setEmailError] = useState(false);
  const [openListModal, setOpenListModal] = useState(false);
  const [listTitle, setListTitle] = useState("");
  const [showToaster, setShowToaster] = useState(false);
  const [headerChecked, setHeaderChecked] = useState(false);

  const fetchingIndividualEmails = () => {
    setIsLoading(true);
    const api = `${
      BaseUrl.baseurl
    }/email-marketing/user-email/get-individual-email-data/${
      userDetails && userDetails.details._id
    }`;
    axios
      .get(api, {
        headers: {
          Authorization: `Bearer ${userDetails && userDetails.token}`,
        },
      })
      .then((response) => {
        if (response.data.status) {
          const results = response.data.details.ToEmail.map((email) => ({
            ...email,
            checked: false,
          }));
          setAllIndividualEmails(results);
          setAllIndividualEmailsCopy(results);
        } else {
          setAllIndividualEmails([]);
          setAllIndividualEmailsCopy([]);
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const getEmailName = (email) => {
    const atIndex = email.indexOf("@"); // Find the position of the '@' symbol
    if (atIndex !== -1) {
      const name = email.slice(0, atIndex); // Extract the part before '@'
      return name;
    } else {
      return "-";
    }
  };
  useEffect(() => {
    fetchingIndividualEmails();
  }, [fetched, props.data]);

  useEffect(() => {
    getAllNameList();
  }, []);

  const addContactToNameList = () => {
    let nameListData = {
      contact: selected.map((val) => {
        let single = {
          Name: val.Name,
          Email: val.Email,
          Phone: val.Phone,
          SendingOption: val.Verified,
        };
        return single;
      }),
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/contact/add-contact-name-list/${
          userDetails && userDetails.details._id
        }/${nameListObj._id}`,
        nameListData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        console.log("rres", response);
        if (response.data.status) {
          setOpenModal(false);
          // createContactListName()
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        const results = allIndividualEmails.map((email) => ({
          ...email,
          checked: false,
        }));
        setAllIndividualEmails(results);
        setAllIndividualEmailsCopy(results);
        setHeaderChecked(false);
        setSelected([]);
        toast.success(
          "Successfully selected emails added to the selected list"
        );
        setNameList("");
      })
      .catch((err) => console.log("Error"));
  };
  const handleHeaderChange = (e) => {
    setHeaderChecked(e.target.checked);
    if (e.target.checked) {
      const results = allIndividualEmails.map((email) => ({
        ...email,
        checked: email.Verified ? true : false,
      }));
      setAllIndividualEmails(results);
      setAllIndividualEmailsCopy(results);

      const filteredResults = allIndividualEmails.filter(
        (email) => email.Verified === true
      );
      setSelected(filteredResults);
    } else {
      const results = allIndividualEmails.map((email) => ({
        ...email,
        checked: false,
      }));
      setAllIndividualEmails(results);
      setAllIndividualEmailsCopy(results);
      setSelected([]);
    }
  };
  const EnhancedTableHead = () => {
    return (
      <TableHead>
        <TableRow>
          {allIndividualEmails.length !== 0 && (
            <TableCell padding="checkbox">
              <Checkbox
                sx={{
                  color: "#1C485F",
                  "&.Mui-checked": {
                    color: "#1C485F",
                  },
                }}
                onChange={handleHeaderChange}
                checked={headerChecked}
                inputProps={{
                  "aria-label": "select all items",
                }}
              />
            </TableCell>
          )}

          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? "center" : "left"}
              padding={
                allIndividualEmails.length === 0
                  ? "normal"
                  : headCell.disablePadding
                  ? "none"
                  : "normal"
              }
              sx={{
                color: "#4B4B4B",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 700,
              }}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };
  const renderStatusUi = (Verified) => {
    switch (Verified) {
      case true:
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              backgroundColor: "#E9F7E9",
              padding: "5px 8px",
              borderRadius: "20px",
            }}
          >
            <div
              style={{
                backgroundColor: "#53D86A",
                height: "8px",
                width: "8px",
                borderRadius: "20px",
              }}
            ></div>
            <p style={{ color: "#53D86A" }}>valid</p>
          </div>
        );
      case "Risk":
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              backgroundColor: "#FDF2E1",
              padding: "5px 8px",
              borderRadius: "20px",
            }}
          >
            <div
              style={{
                backgroundColor: "#D4AB3D",
                height: "8px",
                width: "8px",
                borderRadius: "20px",
              }}
            ></div>
            <p style={{ color: "#D4AB3D" }}>Risk</p>
          </div>
        );
      case false:
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              backgroundColor: "#FFEDE8",
              padding: "5px 8px",
              borderRadius: "20px",
            }}
          >
            <div
              style={{
                backgroundColor: "#FF3434",
                height: "8px",
                width: "8px",
                borderRadius: "20px",
              }}
            ></div>
            <p style={{ color: "#FF3434" }}>Invalid</p>
          </div>
        );
      default:
        return null;
    }
  };
  const getAllNameList = () => {
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/contact/get-all-name-list/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setNameListArr(response.data.details);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  };
  const handleChange6 = (event) => {
    setNameList(event.target.value);
    nameListArr.map((val) => {
      if (val.Name === event.target.value) {
        setNameListObj(val);
      }
    });
  };
  const [catchSearchValue, setCatchSearchValue] = useState("")
  useEffect(() => {
    const filteredRecords = allIndividualEmailsCopy.filter((row) =>
      row.Name.toLowerCase().includes(catchSearchValue.toLowerCase())
    );
    if (filteredRecords.length > 0) {
      setAllIndividualEmails(filteredRecords);
    } else {
      setAllIndividualEmails([]);
    }
  }, [catchSearchValue]);

  const EnhancedTableToolbar = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "4px 16px",
          borderBottomWidth: "1.2px",
          marginBottom: "12px",
        }}
      >
        <Button
          disableRipple
          disableElevation
          sx={{
            cursor: "default",
            outline: "none !important",
            borderBottom: "2px solid #1C485F",
            borderRadius: 0,
            color: "#1C485F",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Typography
            style={{
              color: "#1C485F",
              fontSize: "15px",
              fontWeight: 700,
              fontFamily: "Source Sans 3",
            }}
            component="h2"
          >
            Verified Single Email List
          </Typography>
        </Button>
        <div
        style={{
          display: "flex",
          gap:'8px',
          alignItems: "center",
        }}
        >
          <div
            style={{
              backgroundColor: "#FAFAFA",
              display: "flex",
              alignItems: "center",
              padding: "0px 2px",
              borderRadius: "5px",
              border: "1px solid #1C485F",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M9.58268 17.5001C13.9549 17.5001 17.4993 13.9557 17.4993 9.58341C17.4993 5.21116 13.9549 1.66675 9.58268 1.66675C5.21043 1.66675 1.66602 5.21116 1.66602 9.58341C1.66602 13.9557 5.21043 17.5001 9.58268 17.5001Z"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.3327 18.3334L16.666 16.6667"
                stroke="#868686"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <input
              value={catchSearchValue}
              onChange={(e)=>{setCatchSearchValue(e.target.value)}}
              placeholder="Search..."
              type="text"
              style={{
                outline: "none",
                padding: "9px 8px",
                backgroundColor: "transparent",
              }}
            />
          </div>
          {selected.length > 0 && (
            <button
              onClick={() => setOpenModal(true)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "12px",
                borderRadius: "5px",
                outline: "none",
                border: `1.5px solid #1C485F`,
                color: "#1C485F",
                padding: "8px 10px",
                backgroundColor: "transparent",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 21 20"
                fill="none"
              >
                <path
                  d="M14.7656 17.0837H6.43229C3.93229 17.0837 2.26562 15.8337 2.26562 12.917V7.08366C2.26562 4.16699 3.93229 2.91699 6.43229 2.91699H14.7656C17.2656 2.91699 18.9323 4.16699 18.9323 7.08366V12.917C18.9323 15.8337 17.2656 17.0837 14.7656 17.0837Z"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.7669 7.5L12.1586 9.58333C11.3003 10.2667 9.89192 10.2667 9.03359 9.58333L6.43359 7.5"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Send email
            </button>
          )}
        </div>
      </Box>
    );
  };

  function createNewNameList() {
    let nameListDatas = {
      name: listTitle,
    };
    axios
      .post(
        `${BaseUrl.baseurl}/email-marketing/contact/create-name-list/${
          userDetails && userDetails.details._id
        }`,
        nameListDatas,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setOpenListModal(false);
          getAllNameList();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 3000, // milliseconds
          });
          // setShowToaster(true);
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  const handleCloseModal = () => setOpenListModal(false);

  const handleCreateList = (e) => {
    setListTitle(e.target.value);
  };
  const createListModal = () => {
    return (
      <div>
        <Modal
          open={openListModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <h1
              style={{
                lineHeight: "12px",
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "16px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Create a new list
            </h1>
            <p
              style={{
                padding: "16px 0px",
                color: "#868686",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
              }}
            >
              What would you like to name it?
            </p>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                margin: "0px 0px 10px 0px",
              }}
            >
              <label
                htmlFor="createList"
                style={{
                  color: "#393939",
                  fontFamily: "Source Sans 3",
                  fontSize: "12px",
                  fontWeight: 700,
                }}
              >
                List Name
              </label>
              <input
                name="title"
                value={listTitle}
                onChange={handleCreateList}
                type="text"
                placeholder="Ex:List-sample-A"
                id="createList"
                style={{
                  outline: "none",
                  padding: "12px",
                  backgroundColor: "#FAFAFA",
                  borderRadius: "4px",
                  border: "1px solid #1C485F",
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "8px",
              }}
            >
              <Button
                disableRipple
                disableElevation
                onClick={() => setOpenListModal(false)}
                sx={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none !important",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                disableRipple
                disableElevation
                onClick={() => {
                  createNewNameList();
                }}
                style={{
                  textTransform: "none",
                  background: "#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Continue
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    );
  };

  const muiModal = () => {
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h1"
                style={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "20px",
                  color: "#4B4B4B",
                }}
              >
                Add to list
              </Typography>
              <Button
                disableRipple
                disableElevation
                sx={{
                  display: "flex",
                  outline: "none !important",
                  justifyContent: "flex-end",
                  padding: "0px",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
                onClick={() => setOpenModal(false)}
              >
                <span className="sr-only">Close</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.16992 14.8299L14.8299 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.8299 14.8299L9.16992 9.16992"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Button>
            </Box>

            <Typography
              id="transition-modal-description"
              style={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#868686",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              In which list do you want to add the {selected.length} selected
              contacts?
            </Typography>
            <Typography
              style={{
                padding: "4px 0px",
                fontSize: "14px",
                color: "#4B4B4B",
                fontWeight: "400",
                fontStyle: "normal",
                lineHeight: "20px",
                fontFamily: "Source Sans 3",
              }}
            >
              List name
            </Typography>
            <FormControl
              variant="filled"
              style={{
                minWidth: "100%",
                margin: "6px 0px",
                borderRadius: "4px",
              }}
            >
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={nameList || "Select a list name"}
                disableUnderline
                variant="standard"
                displayEmpty
                onChange={handleChange6}
                IconComponent={ArrowDropDownIcon}
                renderValue={(nameList) => {
                  if (nameList.length === 0) {
                    return <em>Select a List name</em>;
                  }
                  return nameList;
                }}
                sx={{
                  color: "var(--color-dark-600, #727272)",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "20px",
                  padding: "8px",
                  background: "var(--background-color, #FAFAFA)",
                }}
              >
                <MenuItem disabled value="">
                  <em>Select a list name</em>
                </MenuItem>
                {nameListArr.length !== 0 &&
                  nameListArr.map((val) => {
                    return (
                      <MenuItem
                        sx={{
                          color: "var(--color-dark-600, #727272)",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontStyle: "normal",
                          fontWeight: 400,
                          lineHeight: "20px",
                        }}
                        value={val.Name}
                      >
                        {val.Name}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "12px",
                gap: "13px",
              }}
            >
              <button
                onClick={() => {
                  setOpenModal(false);
                }}
                style={{
                  border: "1px solid #1C485F",
                  outline: "none",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  borderRadius: "4px",
                }}
              >
                Cancel
              </button>
              {nameListArr.length === 0 ? (
                <button
                  style={{
                    background: "#1C485F",
                    outline: "none",
                    color: "#fff",
                    padding: "10px 16px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    setOpenListModal(true);
                    setListTitle("");
                    setOpenModal(false);
                  }}
                >
                  Create a list
                </button>
              ) : (
                <button
                  disabled={nameListObj.Name === undefined}
                  onClick={() => {
                    addContactToNameList();
                  }}
                  style={{
                    textTransform: "none",
                    background:
                      nameListObj.Name === undefined ? "#D1DFE9" : "#1C485F",
                    outline: "none",
                    color: nameListObj.Name === undefined ? "#1C485F" : "#fff",
                    padding: "10px 26px",
                    fontSize: "14px",
                    fontWeight: "400",
                    borderRadius: "6px",
                  }}
                >
                  Add
                </button>
              )}
            </div>
          </Box>
        </Fade>
      </Modal>
    );
  };
  return (
    <Box>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "60px 0px",
          }}
        >
          <CircularProgress sx={{ color: "#1C485F" }} />
        </div>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Paper
            sx={{
              width: "100%",
              pb: 2,
              boxShadow: "0",
              borderRadius: "12px",
            }}
          >
            {EnhancedTableToolbar()}
            <TableContainer>
              <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
                size="small"
              >
                {EnhancedTableHead()}
                {allIndividualEmails.length !== 0 && (
                  <TableBody>
                    {allIndividualEmails &&
                      allIndividualEmails?.map((row, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            disabled={!row.Verified}
                            key={row._id}
                            sx={{
                              backgroundColor:
                                index % 2 === 0 ? "#fff" : "#FAFAFA",
                            }}
                          >
                            <TableCell
                              padding="checkbox"
                              sx={{ border: "none" }}
                            >
                              <Checkbox
                                checked={row.checked}
                                disabled={!row.Verified}
                                inputProps={{
                                  "aria-labelledby": "controlled",
                                }}
                                sx={{
                                  color: "#1C485F",
                                  "&.Mui-checked": {
                                    color: "#1C485F",
                                  },
                                }}
                                onClick={() => {
                                  allIndividualEmails.map((val) => {
                                    if (val._id === row._id) {
                                      val.checked = !val.checked;
                                    }
                                  });
                                  setAllIndividualEmails([
                                    ...allIndividualEmails,
                                  ]);
                                  setAllIndividualEmailsCopy([
                                    ...allIndividualEmails,
                                  ]);
                                  if (row.checked) {
                                    setSelected((prevState) => [
                                      ...prevState,
                                      row,
                                    ]);
                                  } else {
                                    setSelected((prevState) =>
                                      prevState.filter(
                                        (selectedPlan) =>
                                          selectedPlan._id !== row._id
                                      )
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                              sx={{ border: "none" }}
                            >
                              <p
                                style={{
                                  color: !row.Verified ? "#BDBDBD" : "#4B4B4B",
                                  fontFamily: "Source Sans 3",
                                  fontSize: "13px",
                                  fontWeight: 400,
                                  fontStyle: "normal",
                                }}
                              >
                                {row.Email}
                              </p>
                            </TableCell>
                            <TableCell sx={{ border: "none" }} align="center">
                              {row.Name === "" ? "-" : row.Name}
                            </TableCell>
                            {/* <TableCell sx={{ border: "none" }} align="center">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      padding: "3px 0px",
                                    }}
                                  >
                                    <button
                                      disabled={!row.Verified}
                                      onClick={() => {
                                        setOpenModal(true)
                                        setSelected([row])
                                      }}
                                      style={{
                                        fontSize: "10px",
                                        borderRadius: "4px",
                                        outline: "none",
                                        border: `1.5px solid ${!row.Verified ? "#B3C9DA" :"#1C485F"}`,
                                        color: `${!row.Verified ? "#FFA2B4" :"#1C485F"}`,
                                        padding: "7px 10px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "8px",
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 21 20"
                                        fill="none"
                                      >
                                        <path
                                          d="M7.4668 10H14.1335"
                                          stroke={`${!row.Verified ? "#FFA2B4":"#1C485F" }`}
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M10.8008 13.3334V6.66669"
                                          stroke={`${!row.Verified ? "#FFA2B4":"#1C485F" }`}
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                        <path
                                          d="M8.30013 18.3334H13.3001C17.4668 18.3334 19.1335 16.6667 19.1335 12.5V7.50002C19.1335 3.33335 17.4668 1.66669 13.3001 1.66669H8.30013C4.13346 1.66669 2.4668 3.33335 2.4668 7.50002V12.5C2.4668 16.6667 4.13346 18.3334 8.30013 18.3334Z"
                                          stroke={`${!row.Verified ? "#FFA2B4":"#1C485F" }`}
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </svg>
                                      Add to list
                                    </button>
                                  </div>
                                </TableCell> */}
                            <TableCell sx={{ border: "none" }} align="center">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                {renderStatusUi(row.Verified)}
                              </div>
                            </TableCell>
                            <TableCell sx={{ border: "none" }} align="center">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  disabled={!row.Verified}
                                  style={{
                                    fontSize: "10px",
                                    borderRadius: "4px",
                                    outline: "none",
                                    border: `1.5px solid ${
                                      !row.Verified ? "#B3C9DA" : "#1C485F"
                                    }`,
                                    color: !row.Verified
                                      ? "#B3C9DA"
                                      : "#1C485F",
                                    padding: "7px 10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "8px",
                                    backgroundColor: !row.Verified
                                      ? "transparent"
                                      : "#fff",
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 21 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M14.7656 17.0837H6.43229C3.93229 17.0837 2.26562 15.8337 2.26562 12.917V7.08366C2.26562 4.16699 3.93229 2.91699 6.43229 2.91699H14.7656C17.2656 2.91699 18.9323 4.16699 18.9323 7.08366V12.917C18.9323 15.8337 17.2656 17.0837 14.7656 17.0837Z"
                                      stroke={`${
                                        !row.Verified ? "#B3C9DA" : "#1C485F"
                                      }`}
                                      stroke-width="1.5"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M14.7669 7.5L12.1586 9.58333C11.3003 10.2667 9.89192 10.2667 9.03359 9.58333L6.43359 7.5"
                                      stroke={`${
                                        !row.Verified ? "#B3C9DA" : "#1C485F"
                                      }`}
                                      stroke-width="1.5"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Send email
                                </button>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                )}
              </Table>
              {allIndividualEmails.length === 0 && (
                <div
                  style={{
                    padding: "30px 12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingBottom: "12px",
                      padding: "12px 0px",
                      backgroundColor: "#FAFAFA",
                      borderRadius: "10px",
                    }}
                  >
                    <p
                      style={{
                        color: "#4B4B4B",
                        fontSize: "20px",
                        fontWeight: 700,
                        fontFamily: "Source Sans 3",
                        fontStyle: "normal",
                      }}
                    >
                      No Data available
                    </p>
                  </div>
                </div>
              )}
            </TableContainer>
          </Paper>
        </Box>
      )}
      <ToastContainer />
      {openModal && muiModal()}
      {openListModal && createListModal()}
    </Box>
  );
};
export default Mailverification;
